import api from "./axios";

export const loginApi = async (payload, fcmToken) => {
  const response = await api.post("/accounts/login/", payload, {
    headers: {
      "X-Platform": "1",
      ...(fcmToken && { "X-Device-Token": fcmToken }),
    },
  });
  return response.data;
};

export const loginWithOtp = async (payload) => {
  const response = await api.post("/accounts/request-login-otp/", payload, {
    headers: {
      "X-Platform": "1",
    },
  });
  return response.data;
};

export const loginOtpVerification = async (payload, fcmToken) => {
  const response = await api.post("/accounts/verify-login-otp/", payload, {
    headers: {
      "X-Platform": "1",
      ...(fcmToken && { "X-Device-Token": fcmToken }),
    },
  });
  return response.data;
};

export const preRegister = async (payload) => {
  const response = await api.post("/accounts/web/pre-register/", payload);
  return response.data;
};

export const preRegisterOtpVerify = async (payload) => {
  const response = await api.post("/accounts/web/verify-otp/", payload);
  return response.data;
};

export const createAccount = async (payload, fcmToken) => {
  const response = await api.post("/accounts/web/create-account/", payload, {
    headers: {
      "X-Platform": "1",
      ...(fcmToken && { "X-Device-Token": fcmToken }),
    },
  });
  return response.data;
};

export const AccountFor = async (payload) => {
  const response = await api.patch("/accounts/profile-created-for/", payload);
  return response.data;
};

export const verifyToken = async () => {
  const res = await api.get("/accounts/protected/");
  return res.data;
};

export const refreshToken = async (payload) => {
  const response = await api.post("/accounts/token/refresh/", payload);
  return response.data;
};

export const logoutApi = async (payload) => {
  const response = await api.post("/accounts/logout/", payload);
  return response.data;
};

export const requestForgotPasswordOtp = async (payload) => {
  // payload = { identifier: "user@example.com" }
  const response = await api.post("/common/send-otp", payload);
  return response.data;
};

export const verifyForgotPasswordOtp = async ({
  identifier,
  otp,
  countrycode,
}) => {
  const response = await api.post("/common/verify-otp", {
    identifier,
    otp,
    countrycode,
  });
  return response.data;
};

export const changePassword = async ({
  new_password,
  confirm_password,
  token,
}) => {
  const response = await api.post(
    "/accounts/reset-password/",
    { new_password, confirm_password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const googleLogin = async ({ token }) => {
  const response = await api.post("/accounts/google/login/", { token });
  return response.data;
};
